const AdminAuth = {
  /**
   *Account
   */

  login: {
    url: "/login",
    method: "POST",
  },
  signup: {
    url: "/registerVendor",
    method: "POST",
  },
  forgotPassword: {
    url: "/forgot-password",
    method: "POST",
  },
  resendOtp: {
    url: "/resend-otp",
    method: "POST",
  },
  resetPassword: {
    url: "/reset-password",
    method: "POST",
  },
  getVendorProfile: (id) => ({
    url: `/vendor/${id}`,
    method: "GET",
  }),
  vendorProfile: (id) => ({
    url: `/updateVendor/${id}`,
    method: "PUT",
  }),
  verifyOTP: (id) => ({
    url: `/verify_otp/${id}`,
    method: "POST",
  }),
  changePassword: (id) => ({
    url: `/changePassword/${id}`,
    method: "POST",
  }),
};
export default AdminAuth;
